import { gql } from "@apollo/client";

export const PREVIEW_MASK_AND_STAMP = gql`
  mutation previewMaskAndStamp(
    $templateId: String
    $clientIdentifier: String
    $maskInput: [TemplateMaskInput]
    $stampInput: TemplateStampInput
  ) {
    invoiceInterpretation {
      previewMaskAndStamp(
        templateId: $templateId
        clientIdentifier: $clientIdentifier
        maskInput: $maskInput
        stampInput: $stampInput
      ) {
        content
        contentType
        name
      }
    }
  }
`;
